import React, { useState } from 'react';
import { Table, Typography } from 'antd';

const { Title } = Typography;

export const TableView = ({ data }) => {
    const [currentPage, setCurrentPage] = useState(1);

    const columns = Object.keys(data.table[0]).map((key) => ({
        title: key.replace(/_/g, ' '),
        dataIndex: key,
        key,
    }));

    return (
        <div className='p-4'>
            <Table
                columns={columns}
                dataSource={data.table.map((item, index) => ({
                    ...item,
                    key: index,
                }))}
                pagination={{
                    pageSize: 4,
                    current: currentPage,
                    onChange: setCurrentPage,
                }}
                scroll={{ x: true }}
            />
            {data.post_fix && (
                <div className='mt-2'>
                    <ul className='list-disc ml-6'>
                        {data.post_fix.map((question, index) => (
                            <li key={index}>{question}</li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};
